<template>
  <div>
    <b-button variant="primary" @click="login" >Login Google</b-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LogInForm',
  methods: {
    ...mapActions([
      'logInGoogle'
    ]),
    login () {
      this.logInGoogle()
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
